import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, Button } from '@chakra-ui/react'

export function AlertSuccessfully({ onClose, isOpen, codParc }) {
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Cliente Cadastrado com Successo
          </AlertDialogHeader>

          <AlertDialogBody>
            O cliente foi cadastrado com sucesso, o código do cliente é: <strong>{codParc}</strong>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose}>Fechar</Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
